import { Utilities } from './../services/utilities/index';
import { Client } from './client';

export class CustomListAttribute {
  id: string = Utilities.generateId();
  customListId: string;
  name: string;
  createdOn?: Date;
  createdBy?: string;
  modifiedOn?: Date;
  modifiedBy?: string;
  deletedOn?: Date;
  deletedBy?: string;

  constructor(options?: Partial<CustomListAttribute>) {
    if (options) {
      Object.assign(this, options);
    }
  }
}

export class CustomListItemAttributeValue {
  id: string = Utilities.generateId();
  customListItemId: string;
  customListAttributeId: string;
  value: string;
  createdOn?: Date;
  createdBy?: string;
  modifiedOn?: Date;
  modifiedBy?: string;

  constructor(options?: Partial<CustomListItemAttributeValue>) {
    if (options) {
      Object.assign(this, options);
    }
  }
}

export class CustomListItem {
  id: string = Utilities.generateId();
  position: number;
  customListId: string;
  text: string;
  value: string;
  imagePath?: string;
  roleMemberUserId?: string;
  deletedOn?: Date;
  deletedBy?: string;
  attributeValues?: CustomListItemAttributeValue[];

  constructor(options?: Partial<CustomListItem>) {
    if (options) {
      Object.assign(this, options);
    }
  }
}

export class CustomList {
  id: string;
  name: string;
  items: CustomListItem[];
  attributes?: CustomListAttribute[];
  roleId?: string;
  clientId?: string;
  client?: Partial<Client>;
  deletedOn?: Date;
  deletedBy?: string;

  constructor(options?: Partial<CustomList>) {
    if (options) {
      Object.assign(this, options);
    }
  }
}
